import { useInfiniteQuery, useQuery } from "@tanstack/react-query";
import { useCallback, useEffect, useState } from "react";
import { useInView } from "react-intersection-observer";
import debounce from "lodash.debounce";
import { fetchCodeSetNames, fetchHrpCodeEntries } from "../../utils/apiUtils";
import SharedTable from "../benefitPlan/SharedTable";
import Select from 'react-select';

const limit = 20
const CodeEntries = () => {

    const [searchValue, setSearchValue] = useState();
    const [decouncedSearchValue, setDecouncedSearchValue] = useState();
    const [codeSet, setCodeSet] = useState(null);

    const { ref, inView } = useInView();

    const { data: codeSetNames, isLoading: isLoadingCodeSets } = useQuery({
        queryKey: ["code-set-names"],
        queryFn: fetchCodeSetNames,
        staleTime: Infinity,
    });

    const { data, error, fetchNextPage, hasNextPage, isLoading, isPending, isFetching, isFetchingNextPage, status, refetch } = useInfiniteQuery({
        queryKey: ["code-entries", limit, decouncedSearchValue, codeSet?.value],
        queryFn: async ({ pageParam }) => {
            let params = pageParam || {};

            if (decouncedSearchValue) {
                params.searchText = decouncedSearchValue;
            }
            if (codeSet?.value) {
                params.cdSetNm = codeSet.value;
            }

            return await fetchHrpCodeEntries({ ...params, limit });
        },

        select: (data) => {
            //   console.log({ data });
            return { count: data.pages?.[0]?.count, rows: data.pages.map((page) => page.rows).flatMap((x) => x) };
        },
        initialPageParam: 0,
        getNextPageParam: (lastPage, pages) => {
            const hasMore = lastPage?.rows?.length === limit;

            if (!hasMore) return undefined;
            return {
                offset: pages.reduce((accum, page) => {
                    return accum + page.rows.length;
                }, 0),
            };
        },
        staleTime: 0
    });

    useEffect(() => {
        if (inView) {
            fetchNextPage();
        }
    }, [inView]);

    const debouncedChangeHandler = useCallback(
        debounce((event) => {
            setDecouncedSearchValue(event.target.value?.trim());
        }, 500),
        []
    );

    const columns = ['cdSetNm', 'shortNm', 'shortDsc', 'cdEntryTxt', 'srcCd', 'isRetiredInd'];

    return (
        <div className={'container '}>
            <p className='title'>Code Entries  ( {data?.count || 0} )</p>
            <p className="sub-title">HRP coded-value sets used in claim review, denial, and other adjudication rules</p>


            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '1rem 1rem 1rem 0rem', }}>
                <div style={{ display: 'flex', gap: '1rem', alignItems: 'center', width: '100%', flexWrap: 'wrap', }}>

                    <Select
                        name="cdSetNm"
                        className="react-select-container large-input"
                        classNamePrefix="react-select"
                        placeholder={isLoadingCodeSets ? "Loading code sets…" : "Code set"}
                        isClearable
                        isLoading={isLoadingCodeSets}
                        options={(Array.isArray(codeSetNames) ? codeSetNames : codeSetNames?.rows || [])
                            .map((row) => row.cdSetNm)
                            .filter(Boolean)
                            .map((name) => ({ value: name, label: name }))}
                        value={codeSet}
                        onChange={setCodeSet}
                    />

                    <input
                        style={{ fontSize: "1rem", minWidth: "250px", padding: "1rem", borderRadius: ".4rem", border: "1px solid var(--lighterGrey)", outline: "none" }}
                        type="text"
                        id={"search"}
                        placeholder="search..."
                        // list="items"
                        autoComplete="off"
                        // onFocus={() => setCurrentPage(0)}
                        onChange={(e) => {
                            setSearchValue(e.target.value);
                            debouncedChangeHandler(e);
                        }}
                        value={searchValue}
                    />
                </div>
            </div>

            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "0rem 1rem 1rem 0rem" }}>
                <p
                    style={{ cursor: "pointer", color: "var(--red)" }}
                    onClick={() => {
                        setDecouncedSearchValue("");
                        setSearchValue("");
                        setCodeSet(null);
                    }}
                >
                    Clear filters
                </p>

            </div>


            {status === "loading" ? (
                <p>Loading...</p>
            ) : status === "error" ? (
                <span className='danger'>Error: {error.message}</span>
            ) : (
                <>
                    <SharedTable
                        type={"code-entries"}
                        columns={columns}
                        items={data?.rows}
                        activeDraftId={null}
                        hasNextPage={hasNextPage}
                        isFetchingNextPage={isFetchingNextPage}
                        fetchNextPage={fetchNextPage}
                        isFetching={isFetching}
                        isLoading={isLoading}
                        searchText={decouncedSearchValue}
                        // onEditHandler={onEditHandler}
                        // onDetailHandler={onDetailHandler}
                        ref={ref}
                    />
                </>
            )}

        </div>
    )
}

export default CodeEntries